import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const sendReceipt = createAsyncThunk('SEND RECEIPT', async (data, thunkAPI) => {
  const response = await axiosAdmin.post(`${URL.SEND_RECEIPT}/${data.accountId}/${data.date}`, data.formData, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  receiptData: null,
};

export const ReceiptSlice = createSlice({
  name: 'Receipt',
  initialState,
  reducers: {},
  extraReducers: {
    // get csv data
    [sendReceipt.pending]: (state) => {
      state.isLoading = true;
      state.receiptData = null;
    },
    [sendReceipt.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.receiptData = action.payload.data;
    },
    [sendReceipt.rejected]: (state, action) => {
      state.isLoading = false;
      state.receiptData = null;
      toast.error(action?.payload?.message);
    },
  },
});

export default ReceiptSlice.reducer;
